/* REVE: favorite hearts wired to Swym Wishlist Plus (JS SDK).
 * - Product cards render <button data-reve-heart data-empi data-epi data-du> in product-card.liquid.
 * - The product page gets one heart injected into the media viewer (from #ProductData).
 * - State is read from swat.fetch(); clicks call swat.addToWishList / removeFromWishList.
 * - Nothing here touches the cart: rentals are only ever booked on the product page.
 */
(function () {
  'use strict';

  var SEL = '[data-reve-heart]';
  var swat = null;
  var saved = {}; // empi -> wishlist item {empi, epi, du, lid}
  var pending = {};
  var repaintTimer = null;

  var HEART_SVG =
    '<svg class="reve-heart__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.5s-7.5-4.6-9.4-9.1C1.3 8.3 3 5 6.3 4.5c2-.3 3.9.6 5.7 2.7 1.8-2.1 3.7-3 5.7-2.7 3.3.5 5 3.8 3.7 6.9-1.9 4.5-9.4 9.1-9.4 9.1z"/></svg>';

  function paint(btn) {
    var empi = btn.getAttribute('data-empi');
    var on = !!saved[empi];
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var title = btn.getAttribute('data-title') || '';
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + (title ? title + ' ' : '') + (on ? 'from your favorites' : 'to your favorites'));
  }

  function paintAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) paint(nodes[i]);
  }

  function schedulePaint() {
    clearTimeout(repaintTimer);
    repaintTimer = setTimeout(paintAll, 60);
  }

  var refreshTimer = null;

  function hasPending() {
    for (var k in pending) if (pending[k]) return true;
    return false;
  }

  // Re-read the list from Swym. Debounced, and never while a click is in flight —
  // Swym can hand back a cached pre-change list for a moment, which would flip a heart.
  function refresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (!swat || hasPending()) { refresh(400); return; }
      swat.fetch(function (items) {
        if (hasPending()) return;
        saved = {};
        (items || []).forEach(function (it) {
          if (it && it.empi != null) saved[String(it.empi)] = it;
        });
        paintAll();
      }, function () {
        /* keep last known state */
      });
    }, delay == null ? 250 : delay);
  }

  function productFrom(btn) {
    return {
      empi: parseInt(btn.getAttribute('data-empi'), 10),
      epi: parseInt(btn.getAttribute('data-epi'), 10),
      du: btn.getAttribute('data-du')
    };
  }

  function toggle(btn) {
    if (!swat) return;
    var empi = btn.getAttribute('data-empi');
    if (pending[empi]) return;
    pending[empi] = true;
    btn.classList.add('is-busy');

    var finish = function () {
      delete pending[empi];
      btn.classList.remove('is-busy');
      paintAll();          // any other heart for the same product follows

      // On the favourites page, a piece that is no longer saved leaves the grid.
      var favHost = document.querySelector('[data-reve-favorites]');
      if (favHost && !saved[empi]) {
        var col = btn.closest ? btn.closest('.f-column') : null;
        if (col && favHost.contains(col)) {
          col.remove();
          var g = favHost.querySelector('[data-reve-favorites-grid]');
          if (g && !g.children.length) renderFavorites();   // falls back to the empty state
        }
      }

      refresh(1500);       // settle from the server once Swym has caught up
    };

    if (saved[empi]) {
      var it = saved[empi];
      var p = { empi: it.empi, epi: it.epi, du: it.du || btn.getAttribute('data-du') };
      delete saved[empi];  // optimistic
      paint(btn);
      swat.removeFromWishList(p, finish, function () {
        saved[empi] = it;  // revert
        finish();
      });
    } else {
      var np = productFrom(btn);
      saved[empi] = np;    // optimistic
      paint(btn);
      swat.addToWishList(np, finish, function () {
        delete saved[empi]; // revert
        finish();
      });
    }
  }

  // One delegated listener covers cards rendered now, after filtering, and after load-more.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  function injectPdpHeart() {
    var info = document.querySelector('product-info');
    var data = document.getElementById('ProductData');
    var viewer = document.querySelector('.f-product__media-viewer');
    if (!info || !data || !viewer || viewer.querySelector(SEL)) return;
    var product;
    try { product = JSON.parse(data.textContent); } catch (err) { return; }
    if (!product || !product.id) return;
    var variant = null;
    for (var i = 0; i < (product.variants || []).length; i++) {
      if (product.variants[i].available) { variant = product.variants[i]; break; }
    }
    variant = variant || (product.variants && product.variants[0]);
    if (!variant) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'reve-heart reve-heart--pdp';
    btn.setAttribute('data-reve-heart', '');
    btn.setAttribute('data-empi', String(product.id));
    btn.setAttribute('data-epi', String(variant.id));
    btn.setAttribute('data-du', location.origin + '/products/' + product.handle);
    btn.setAttribute('data-title', product.title || '');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = HEART_SVG;
    var host = viewer.firstElementChild || viewer;
    host.appendChild(btn);
    paint(btn);
  }

  // The theme opens a photoswipe lightbox when the product image is clicked, but renders no
  // icon for it (the toggle is a 0x0 button whose ::after covers the image). Give it one,
  // top-left, mirroring the heart -- and just forward the click to the theme's own button so
  // the lightbox behaviour stays entirely theirs.
  var ZOOM_SVG =
    '<svg class="reve-zoom__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
    'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<circle cx="11" cy="11" r="7"></circle><line x1="16.2" y1="16.2" x2="21" y2="21"></line>' +
    '<line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

  function injectPdpZoom() {
    var viewer = document.querySelector('.f-product__media-viewer');
    if (!viewer || !document.querySelector('product-info') || viewer.querySelector('.reve-zoom')) return;
    if (!viewer.querySelector('.js-photoswipe--zoom')) return;   // nothing to open

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'reve-zoom';
    btn.setAttribute('aria-label', 'View larger');
    btn.innerHTML = ZOOM_SVG;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var t = viewer.querySelector('.f-product__media.is-selected .js-photoswipe--zoom') ||
              viewer.querySelector('.js-photoswipe--zoom');
      if (t) t.click();
    });
    (viewer.firstElementChild || viewer).appendChild(btn);
  }

  function boot(s) {
    swat = s;
    injectPdpHeart();
    injectPdpZoom();
    if (document.querySelector('[data-reve-favorites]')) renderFavorites();
    refresh(0);

    // Keep hearts in sync with the Swym drawer / other tabs.
    var ev = swat.JSEvents || {};
    var layer = swat.evtLayer || document;
    ['addedToWishlist', 'removedFromWishlist', 'removedWishlist', 'listContentsChanged'].forEach(function (k) {
      if (ev[k]) layer.addEventListener(ev[k], function () { refresh(800); });
    });
    if (ev.customerLogin) layer.addEventListener(ev.customerLogin, function () { refresh(0); });
  }

  // --- Swym drawer: no cart actions, no owner price, product links instead --------------
  // Rentals must go through the product page (Supercycle dates), so any "Add to cart" in the
  // Swym UI is redirected to the product instead. The CSS hides the buttons; this is the guard.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.swym-storefront-layout-root-component button[class*="add-to-cart"], .swym-storefront-layout-root-component button[class*="move-to-cart"]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var item = b.closest('[class*="grid-item"]');
    var link = item && item.querySelector('a[href*="/products/"]');
    if (link) location.href = link.href;
  }, true);

  // The drawer is React-rendered, so we only touch text (the "View & choose dates" link
  // under each item is a CSS ::after on the title link, see reve-overrides.css).
  // Swym's stock copy sells with urgency ("catch a drop before it's too late"), which the
  // brand rules rule out. Replaced here; the bullet card it sits above is hidden in CSS.
  var DRAWER_TEXT = [
    ['.swym-storefront-layout-title', 'Your favorites'],
    ['.swym-storefront-layout-empty-wishlist-title', 'Nothing saved yet'],
    ['.swym-storefront-layout-empty-wishlist-description',
     'Tap the heart on any piece and it will wait for you here.']
  ];

  function dressDrawer(root) {
    for (var i = 0; i < DRAWER_TEXT.length; i++) {
      var el = root.querySelector(DRAWER_TEXT[i][0]);
      // Only write when it differs, so the MutationObserver below cannot loop.
      if (el && el.textContent.trim() !== DRAWER_TEXT[i][1]) el.textContent = DRAWER_TEXT[i][1];
    }
  }

  function watchDrawer() {
    var root = document.querySelector('.swym-storefront-layout-root-component');
    if (!root || root.__reveDressed) return;
    root.__reveDressed = true;
    dressDrawer(root);
    new MutationObserver(function () { dressDrawer(root); }).observe(root, { childList: true, subtree: true });
  }

  // --- Swym "add to wishlist" button on the PDP -------------------------------------
  // Swym's app embed injects this under Add to bag. The site calls the list "favorites"
  // everywhere else, so the label follows. Styling lives in reve-overrides.css.
  function dressAtw() {
    var btns = document.querySelectorAll('.atw-button');
    for (var i = 0; i < btns.length; i++) {
      var label = btns[i].querySelector('.atw-button-text');
      if (!label) continue;
      var want = btns[i].classList.contains('atw-button-added')
        ? 'Saved to favorites'
        : 'Save to favorites';
      // Only write when it differs, so the observer below cannot loop.
      if (label.textContent.trim() !== want) label.textContent = want;
    }
  }

  function watchAtw() {
    var host = document.querySelector('.swym-atw-button-container');
    if (!host || host.__reveAtwWatched || !window.MutationObserver) return;
    host.__reveAtwWatched = true;
    dressAtw();
    new MutationObserver(dressAtw).observe(host, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
  }

  // --- Swym "save for later" prompt (cart line removal) ------------------------------
  // Swym's stock copy carries an exclamation point ("No, thanks!") and its meta line
  // renders as "6 1 Qty". Both are rewritten here; the card itself is restyled in
  // reve-overrides.css.
  var SFL_TEXT = [
    ['.swym-cc-sfl-popup-content .swym-modal-heading', 'Keep this piece for later?'],
    ['.swym-sfl-popup-cancel', 'Not now'],
    ['.swym-sfl-popup-save-btn', 'Save for later']
  ];

  function sizeLabel(v) {
    return /^([0-9]|xxs|xs|s|m|l|xl|xxl)/i.test(v) ? 'Size ' + v : v;
  }

  function dressSflMeta(p) {
    if (p.__reveMeta) return;
    var span = p.querySelector('span');
    // Swym leaves a trailing pipe separator inside the title span.
    var title = span ? span.textContent.replace(/[\s|]+$/, '').trim() : '';
    var bits = [];
    for (var i = 0; i < p.childNodes.length; i++) {
      var n = p.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim() && n.textContent.trim() !== '|') {
        bits.push(n.textContent.trim());
      }
    }
    // bits is [variant, quantity, "Qty"] in Swym's stock order.
    if (!title || bits.length < 2) return;
    p.__reveMeta = true;
    p.textContent = title + ' \u00b7 ' + sizeLabel(bits[0]) + ' \u00b7 Qty ' + bits[1];
  }

  function dressSfl() {
    var dialog = document.querySelector('.swym-sfl-popup-dialog');
    if (!dialog) return;
    for (var i = 0; i < SFL_TEXT.length; i++) {
      var nodes = dialog.querySelectorAll(SFL_TEXT[i][0]);
      for (var j = 0; j < nodes.length; j++) {
        // Only write when it differs, so the observer below cannot loop.
        if (nodes[j].textContent.trim() !== SFL_TEXT[i][1]) nodes[j].textContent = SFL_TEXT[i][1];
      }
    }
    var meta = dialog.querySelector('.swym-cc-sfl-popup-content > p');
    if (meta) dressSflMeta(meta);
  }

  function watchSfl() {
    var host = document.querySelector('.swym-modals-container') || document.body;
    if (!host || host.__reveSflWatched || !window.MutationObserver) return;
    host.__reveSflWatched = true;
    dressSfl();
    new MutationObserver(dressSfl).observe(host, { childList: true, subtree: true });
  }

  // --- Favorites page (/pages/favorites) --------------------------------------------
  // Swym's own wishlist UI can only print the variant price, and its customer-accounts
  // page can't be styled at all -- so we render the list ourselves. Each card is pulled
  // from the reve-favorite-card section, which means it is the site's real product card,
  // rental price and all.
  function favHandle(du) {
    if (!du) return null;
    var path = du;
    try { if (du.indexOf('://') > -1) path = new URL(du).pathname; } catch (e) { /* keep raw */ }
    var m = path.split('?')[0].split('#')[0].replace(/\/+$/, '').match(/\/products\/([^/]+)$/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function renderFavorites() {
    var host = document.querySelector('[data-reve-favorites]');
    if (!host || !swat) return;
    var grid = host.querySelector('[data-reve-favorites-grid]');
    var empty = host.querySelector('[data-reve-favorites-empty]');
    var loading = host.querySelector('[data-reve-favorites-loading]');

    var settle = function (hasItems) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = hasItems;
      if (grid) grid.hidden = !hasItems;
    };

    swat.fetch(function (items) {
      // Every card on this page is by definition saved, so seed the heart state here.
      saved = {};
      var handles = [];
      (items || []).forEach(function (it) {
        if (!it || it.empi == null) return;
        saved[String(it.empi)] = it;
        var h = favHandle(it.du);
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });

      if (!handles.length) { if (grid) grid.innerHTML = ''; settle(false); return; }

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?section_id=reve-favorite-card', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });          // a delisted product just drops out
      })).then(function (chunks) {
        if (!grid) return;
        grid.innerHTML = '';
        chunks.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var col = doc.querySelector('.f-column');     // unwrap Shopify's section wrapper
          if (col) grid.appendChild(document.importNode(col, true));
        });
        settle(grid.children.length > 0);
        paintAll();
      });
    }, function () { settle(false); });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(boot);
  window.SwymCallbacks.push(function () {
    watchDrawer();
    watchSfl();
    watchAtw();
    var tries = 0, t = setInterval(function () {
      watchDrawer(); watchSfl(); watchAtw();
      if (++tries > 20 || document.querySelector('.swym-storefront-layout-root-component')) clearInterval(t);
    }, 500);
  });

  // Filter / sort re-renders and infinite scroll replace the grid: repaint the new hearts.
  document.addEventListener('collection:rerendered', schedulePaint);
  document.addEventListener('DOMContentLoaded', function () {
    injectPdpHeart();
    injectPdpZoom();
    var grid = document.getElementById('ProductGridContainer') || document.querySelector('.collection-product-grid, .f-product-grid, main');
    if (grid && window.MutationObserver) {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) {
          if (m[i].addedNodes && m[i].addedNodes.length) { schedulePaint(); return; }
        }
      }).observe(grid, { childList: true, subtree: true });
    }
  });
})();
